namespace RS.ExternalHelp
{
    /**
     * Removes buyPass lines if not supported
     */
    export class BuyPassPlugin extends RS.ExternalHelp.VisitorPlugin
    {
        private _showBuyPass: string;

        public constructor(page: RS.ExternalHelp.IPage)
        {
            super(page);
            this._showBuyPass = RS.URL.getParameter("buypass");
        }

        public onElementLoaded(element: HTMLElement)
        {
            const eClass = element.className;
            const eID = element.id;
            if (eClass == "buyPass" || eID == "buyPass")
            {
                if (this._showBuyPass == null)
                {
                    RS.ExternalHelp.hideElement(element);
                }
            }
        }
    }
    RS.ExternalHelp.pluginRegistry.register(BuyPassPlugin);
}